module.exports = __webpack_public_path__ + "static/media/something-went-wrong.3c76955e.png";